import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { createThirdPartyDeviceProvider, getIntegrationDevices } from "../thunk/deviceIntegration";

export type DeviceListType = {
  pk: string;
  sk: string;
  providerId: string;
  data: string;
  created_at: string;
  updated_at: string;
}
interface InitialState {
  devices: DeviceListType[];
  loading: boolean;
  fetchedListLoader: boolean;
  error: string | null;
}

const initialState: InitialState = {
  devices: [],
  loading: false,
  fetchedListLoader: true,
  error: null,
};

const deviceIntegrationSlice = createSlice({
  name: "deviceIntegration",
  initialState,
  reducers: {
    deviceList: (state: Draft<InitialState>, action: PayloadAction<any>) => {
      state.devices = action.payload;
    },
    setLoader: (state: Draft<InitialState>, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createThirdPartyDeviceProvider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createThirdPartyDeviceProvider.fulfilled, (state, action) => {
        state.loading = false;
        // state.devices.push(action.payload);
      })
      .addCase(createThirdPartyDeviceProvider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder.addCase(getIntegrationDevices.pending, (state) => {
      state.fetchedListLoader = true;
    })
      .addCase(getIntegrationDevices.fulfilled, (state, action) => {
        state.devices = action.payload;
        state.fetchedListLoader = false;
      })
      .addCase(getIntegrationDevices.rejected, (state, action) => {
        state.error = action.payload as string;
        state.devices = [];
        state.fetchedListLoader = false;
      });
  },
});

export const { deviceList, setLoader } = deviceIntegrationSlice.actions;
export const deviceIntegration = deviceIntegrationSlice.reducer;


